<template>
  <router-view/>
</template>


<style src="./assets/style/v2/main.css"></style>
<style>
#app {
  display: block;
  width: 100% !important;
  height: 100% !important;
  margin: 0px !important;
  padding: 0px !important;
}

</style>

<script>

export default {
  name: 'App',
}

</script>
